// extracted by mini-css-extract-plugin
export default {"container":"targets_container__+0JSM","cogTabs":"targets_cogTabs__GEcOZ","tab":"targets_tab__wHMnd"};